var els = $('.rfq-form-a');
if (els.length > 0) {
  require.ensure('../controllers/ticket_message_controller', function(require) {
    var TicketMessageController = require('../controllers/ticket_message_controller');
    els.each(function() {
      return new TicketMessageController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/ticket_message.initializer.js